import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';
import { Maybe } from 'maybe-not';

export default function notifyRefetchAccounts(platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('refetchAccountsNotification')) {
        return;
    }

    return function() {
        sendMessage('refetchAccountsNotification', Maybe.nothing<string>());
    };
}
